import React from 'react';
import MuiButton from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const DayButton = ({
  label,
  color = 'primary',
  size = 'large',
  disabled = false,
  className,
  onClick,
  isVisible = true
}) => {
  const useStyles = makeStyles({
    root: {
      borderRadius: 100,
      minWidth: '36px',
      minHeight: '36px',
      margin: '1.5px',
      marginTop: '1px',
    },
    label: {
      fontSize: '1 rem',
      fontWeight: 700,
      color: process.env.REACT_APP_COLOR_TEXT,
    },
    transparent: {
      '&:hover': {
        backgroundColor: label !== ''
          ? process.env.REACT_APP_COLOR_HOVER_CALENDAR_DAY : process.env.REACT_APP_COLOR_SECONDARY,
        cursor: label !== '' ? 'pointer' : 'default'
      },
    },
    noVisible: {
      borderRadius: 100,
      minWidth: '36px',
      minHeight: '36px',
      margin: '1.5px',
      marginTop: '1px',
    }
  });

  const classes = useStyles();

  return (
    <>
      {
      isVisible
        ? (
          <MuiButton
            className={`${classes.transparent} ${className}`}
            classes={{
              root: classes.root,
              label: classes.label,
            }}
            color={color}
            size={size}
            fullWidth
            onClick={onClick}
            disabled={disabled}
          >
            {label}
          </MuiButton>
        )
        : <div className={classes.noVisible} />
      }
    </>
  );
};

export default DayButton;
